import styled from 'styled-components';

import colors from '../../../styles/colors';

const TabContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: ${colors.base.gamma};
  padding-top: 4px;
`;

const Tab = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 15px;
  border: none;
  background: ${(colors.base.gamma)};
  border-bottom: 2px solid ${({ $active }) => ($active ? colors.base.secondary2 : colors.shades.gamma4)};
  color: ${colors.base.secondary2};
  cursor: pointer;
  width: fit-content;
  transition: background 0.15s ease;
`;

const TabLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 10px;
`;

const TabIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export {
  TabContainer,
  Tab,
  TabLabel,
  TabIconWrapper,
};
